const { endpoint: webVitalsEndpoint } = require('../constants/web-vitals');
const { endpoint: pageRenderEndpoint } = require('../constants/page-render');
const { endpoint: availabilityEndpoint } = require('../constants/availability');
const { endpoint: cdnHealthEndpoint } = require('../constants/cdn-health');
const { endpoint: a11yEndpoint } = require('../constants/a11y');
const { endpoint: sessionReplayEndpoint } = require('../constants/session-replay');
const { endpoint: resourceTimingEndpoint } = require('../constants/resource-timing');
const { preparePayload, prepareFormData } = require('./builder');
const { beaconWithFetchFallback, sendFormDataWithFetch } = require('./utils/send');
const {
  WEB_VITALS,
  PAGE_RENDER,
  A11Y,
  AVAILABILITY,
  CDN_HEALTH,
  RESOURCE_TIMING,
  SESSION_REPLAY,
} = require('../constants/initiatives');
const { sendWebMonitoring } = require('./triggers/web-monitoring');
const { getConfiguration } = require('./config');
const { METRICS } = require('../constants/configurations');

const metricsCollected = {};

const endpoints = {
  [WEB_VITALS]: webVitalsEndpoint,
  [PAGE_RENDER]: pageRenderEndpoint,
  [A11Y]: a11yEndpoint,
  [AVAILABILITY]: availabilityEndpoint,
  [CDN_HEALTH]: cdnHealthEndpoint,
  [RESOURCE_TIMING]: resourceTimingEndpoint,
  [SESSION_REPLAY]: sessionReplayEndpoint,
};

const getMetricsCollected = () => metricsCollected;

const trackMetric = (key, value) => {
  // eslint-disable-next-line security/detect-object-injection
  metricsCollected[key] = value;
};

// eslint-disable-next-line security/detect-object-injection
const checkMetric = (key) => metricsCollected[key] !== undefined;

// eslint-disable-next-line security/detect-object-injection
const getMetric = (key, alt = null) => (checkMetric(key) ? metricsCollected[key] : alt);

const clearMetric = (key) => {
  if (checkMetric(key)) {
    // eslint-disable-next-line security/detect-object-injection
    delete metricsCollected[key];
  }
};

const clearAllMetrics = (initiative) => {
  const metrics = getConfiguration(METRICS, initiative.id);
  (metrics || []).forEach((key) => {
    clearMetric(key);
  });
};

const appendMetric = (key, value) => {
  // eslint-disable-next-line security/detect-object-injection
  (metricsCollected[key] = metricsCollected[key] || []).push(value);
};

const sendMetrics = (initiative, settings, data) => {
  const payload = preparePayload(initiative, settings, data);

  if (!payload) {
    return false;
  }

  sendWebMonitoring(initiative, settings, data);

  beaconWithFetchFallback(endpoints[initiative.id], payload);
  return true;
};

const sendFormData = (initiative, settings, data) => {
  const formData = prepareFormData(initiative, settings, data);
  if (!formData) {
    return false;
  }

  sendFormDataWithFetch(endpoints[initiative.id], formData, false);
  return true;
};

module.exports = {
  trackMetric,
  appendMetric,
  getMetricsCollected,
  sendMetrics,
  sendFormData,
  clearMetric,
  checkMetric,
  getMetric,
  clearAllMetrics,
};
